import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Stage from './Stage'
import { PRESENTATIONS, findPresentation } from './registry'

import { TRoutes } from '../../../../shared/const'
import { formatVienna } from '../../../../shared/datetime'

import styles from './style.module.scss'

/**
 * Präsentationen: die Übersicht als Kacheln, eine geöffnete Präsentation auf
 * der Bühne. Beides unter einer Route (`/praesentationen` und
 * `/praesentationen/:slug`), damit der Menüpunkt in beiden Fällen leuchtet.
 */
export default function Presentations() {
	const { t } = useTranslation()
	const { slug } = useParams()

	if (slug) {
		const p = findPresentation(slug)
		const print = new URLSearchParams(window.location.search).get('druck') === '1'
		if (!p) {
			return (
				<div className={styles.page}>
					<p className={styles.notFound}>{t('presentationNotFound')}</p>
					<Link className={styles.back} to={TRoutes.PRESENTATIONS}>
						← {t('presentationAll')}
					</Link>
				</div>
			)
		}
		const { script, Slides } = p
		const slides = script.SLIDES.map(s => ({ ...s, steps: script.stepsOf(s.id) }))
		return (
			<div className={print ? styles.printPage : styles.page}>
				{!print && (
					<div className={styles.topbar}>
						<Link className={styles.back} to={TRoutes.PRESENTATIONS}>
							← {t('presentationAll')}
						</Link>
						<h1 className={styles.title}>{p.title}</h1>
					</div>
				)}
				<Stage
					slides={slides}
					audioBase={script.AUDIO}
					music={script.MUSIC}
					pdf={script.PDF}
					tempo={p.tempo}
					renderSlide={id => <Slides id={id} />}
				/>
			</div>
		)
	}

	return (
		<div className={styles.page}>
			<div className={styles.head}>
				<h1 className={styles.title}>{t('presentations')}</h1>
				<p className={styles.intro}>{t('presentationsIntro')}</p>
			</div>
			<div className={styles.grid}>
				{PRESENTATIONS.map(p => (
					<Link key={p.slug} className={styles.card} to={TRoutes.PRESENTATION(p.slug)}>
						<div className={styles.cover} style={{ backgroundImage: `url(${p.cover})` }} />
						<div className={styles.cardBody}>
							<h2>{p.title}</h2>
							<p>{p.subtitle}</p>
							<ul className={styles.facts}>
								<li>{p.audience}</li>
								<li>{t('presentationLanguage', { language: p.language })}</li>
								<li>{t('presentationMinutes', { count: p.minutes })}</li>
								<li>{t('presentationSlides', { count: p.script.SLIDES.length })}</li>
								<li>{formatVienna(p.createdAt, 'dd.MM.yyyy')}</li>
							</ul>
							<span className={styles.open}>{t('presentationOpen')} →</span>
						</div>
					</Link>
				))}
			</div>
		</div>
	)
}
